import React from 'react';
import Tooltip from '@reach/tooltip';
import '@reach/tooltip/styles.css';
import './styles.css';
/**
 *  Tooltip que nos permite mostrar información cuando el usuario hacer hover sobre
 *  un elemento
 *
 */

const StyledTooltip = props => <Tooltip className="tooltip" {...props} />;
export default StyledTooltip;
